import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'
import { formatCurrency } from '../helpers'

export default () => {
    const [products, setProducts] = useState([])

    useEffect(() => {
        nostojs((api) => {
            api.createRecommendationRequest().setElements(['nosto-search-noresults-rec']).loadRecommendations()
        })
    }, [])

    return (
        <div class="no-results-autocomplete-container ns-d-flex" style="flex-wrap: wrap;">
            <div class={`ns-d-flex`} style="width: 100%; margin: 30px 0;">
                <span>There are no products matching your query</span>
            </div>
            <div
                class="ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ns-col-sm-3"
                style="flex-direction: column !important; width: 40%;">
                <div class="ns-pb-4 ns-autocomplete-no-results-title">
                    <span>TRENDING SEARCHES</span>
                </div>

                <div class="ns-d-flex ns-flex-column">
                    <div class="ns-autocomplete-element " style="width: 100%; border-bottom: none;">
                        <h2 class="nosto-autocomplete-info__name ns-pb-3">
                            <a href="https://us.laneige.com/collections/all-products/products/lip-sleeping-mask">
                                Lip sleeping masks
                            </a>
                        </h2>
                        <h2 class="nosto-autocomplete-info__name ns-pb-3">
                            <a href="https://us.laneige.com/collections/korean-toner">Korean toner</a>
                        </h2>
                        <h2 class="nosto-autocomplete-info__name ns-pb-3">
                            <a href="https://us.laneige.com/collections/water-bank">Water bank</a>
                        </h2>
                        <h2 class="nosto-autocomplete-info__name ns-pb-3">
                            <a href="https://us.laneige.com/collections/korean-sleeping-masks">
                                Korean sleeping masks
                            </a>
                        </h2>
                        <h2 class="nosto-autocomplete-info__name ns-pb-3">
                            <a href="https://us.laneige.com/collections/cream-skin">Cream skin</a>
                        </h2>
                    </div>
                </div>
            </div>
            <div
                class="ns-noresults-products ns-autocomplete-products ns-d-flex ns-flex-grow-1 nosto-autocomplete-prods-container"
                style="width: 60%; padding-bottom: 40px;">
                <div class="ns-autocomplete-products ns-d-flex ns-flex-grow-1 nosto-autocomplete-prods-container no-results-container">
                    <div class="ns-pb-4 ns-autocomplete-no-results-title">
                        <span>TRY THESE INSTEAD?</span>
                    </div>

                    <div class="ns-d-flex no-results-container">
                        <div class="nosto_element" id="nosto-search-noresults-rec"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
